import { command } from 'ccstate'
import { apiClient$ } from '../infra/apiClient'
import { wordDetailDirty$ } from '../state/wordDetailState'
import { historyDirty$ } from '../state/historyState'
import { favoritesDirty$ } from '../state/favoritesState'

export const addToHistory$ = command(async ({ get, set }, req: {
  wordId: string
  word: string
  briefMeaning: string
}) => {
  const apiClient = get(apiClient$)
  await apiClient.postApi('addSearchHistory', req)

  const currentDirty = get(historyDirty$)
  set(historyDirty$, currentDirty + 1)
})

export const toggleFavorite$ = command(async ({ get, set }, req: {
  wordId: string
  word: string
  partOfSpeech: string
  briefMeaning: string
  isFavorite: boolean
}) => {
  const apiClient = get(apiClient$)

  if (req.isFavorite) {
    await apiClient.postApi('removeFavorite', { wordId: req.wordId })
  } else {
    await apiClient.postApi('addFavorite', {
      wordId: req.wordId,
      word: req.word,
      partOfSpeech: req.partOfSpeech,
      briefMeaning: req.briefMeaning
    })
  }

  const currentFavoritesDirty = get(favoritesDirty$)
  set(favoritesDirty$, currentFavoritesDirty + 1)

  const currentWordDirty = get(wordDetailDirty$)
  set(wordDetailDirty$, currentWordDirty + 1)
})
